import React from 'react';
import { connect } from 'react-redux';
import { fetchServerTime } from 'features/AISDataProvider/actions';
import Wrapper from 'ui/Wrapper';
import FlexWrapper from 'ui/FlexWrapper';
import Headline from 'ui/Headline';
import Text, { TextFrame } from 'ui/Text';
import QuickPickCard from 'features/QuickPickCard';
import { PRODUCT_IDS } from 'configs/products';
import Spinner from 'ui/Spinner';
import AISREST from '../AISREST';
import QuickPickDO from 'common/DataObjects/QuickPick';
import NotificationConductor from 'common/conductors/NotificationConductor';
import { byPlatform } from 'utils/platforms';
import image from 'images/dk/hest-lyn.png';
import iGS75 from './assets/atg-style/GS75.png';
import iV4 from './assets/atg-style/V4-5.png';
import iV5 from './assets/atg-style/V4-5.png';
import iV64 from './assets/atg-style/V64.png';
import iV65 from './assets/atg-style/V65.png';
import iV75 from './assets/atg-style/V75.png';
import iV86 from './assets/atg-style/V86.png';
import moment from 'moment';

import getTexts from 'utils/localization';
const t = getTexts();

const PRODUCT_BACKGROUNDS = {
    GS75: iGS75,
    V4: iV4,
    V5: iV5,
    V64: iV64,
    V65: iV65,
    V75: iV75,
    V86: iV86,
};

const _DATE_FORMAT = 'YYYY-MM-DD';

class QuickPick extends React.Component {
    constructor() {
        super();

        this.state = {
            data: null,
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        this.props.fetchServerTime();

        AISREST.fetchAllPoolInformation()
            .then((res) => {
                if (res.success) {
                    setTimeout(() => {
                        this.setState({
                            data: res.data.map((item) =>
                                QuickPickDO.unserialize(item)
                            ),
                        });
                    }, 200);
                }
            })
            .catch((error) => {
                NotificationConductor.error(error.toString());
            });
    };

    scrollToTop = () => {
        window.scrollTo(0, 0);
    };

    sortData = (data) => {
        let sortedData = data
            ? data.sort((a, b) => (a.date >= b.date ? 1 : -1))
            : null;

        return sortedData;
    };

    getGroupedData = () => {
        let popular = [],
            today = [],
            nextDays = [];

        const data = this.state.data;

        if (data) {
            popular = this.sortData(
                data.filter(
                    (item) =>
                        item.product.id === PRODUCT_IDS.V75 ||
                        item.product.id === PRODUCT_IDS.V86
                )
            );

            today = this.sortData(
                data.filter(
                    (item) =>
                        moment(item.date).format(_DATE_FORMAT) ===
                            moment().format(_DATE_FORMAT) &&
                        item.product.id !== PRODUCT_IDS.V75 &&
                        item.product.id !== PRODUCT_IDS.V86
                )
            );

            nextDays = this.sortData(
                data.filter(
                    (item) =>
                        moment(item.date).format(_DATE_FORMAT) !==
                            moment().format(_DATE_FORMAT) &&
                        item.product.id !== PRODUCT_IDS.V75 &&
                        item.product.id !== PRODUCT_IDS.V86
                )
            );
        }

        return {
            popular,
            today,
            nextDays,
        };
    };

    render() {
        const { popular, today, nextDays } = this.getGroupedData();

        return (
            <Wrapper>
                {byPlatform(
                    <Wrapper padding="20px 30px" data-test-id="title">
                        <Headline
                            size="x2"
                            bolder
                            padding="0px"
                            margin="10px 20px 5px"
                            condensed
                        >
                            {t.QuickPick.Mobile.title}
                        </Headline>

                        <Text padding="0px 20px 10px" condensed>
                            {t.QuickPick.Mobile.description}
                        </Text>
                    </Wrapper>,
                    <FlexWrapper
                        direction="row"
                        padding="0px 10px"
                        data-test-id="title"
                    >
                        <TextFrame pt={70} pl={40} pb={0}>
                            <Headline size="x2" bolder condensed>
                                {t.QuickPick.Desktop.title}
                            </Headline>

                            <Text lh={21} condensed>
                                {t.QuickPick.Desktop.description}
                            </Text>
                        </TextFrame>

                        <Wrapper padding="0px 30px">
                            <img src={image} alt="DerbyLyn" width="400px" />
                        </Wrapper>
                    </FlexWrapper>
                )}

                <Wrapper padding="0px 10px">
                    {popular.length > 0 ? (
                        <TextFrame>
                            <Headline
                                size="x2"
                                condensed
                                padding="0px 10px 10px"
                            >
                                {t.QuickPick.popular}
                            </Headline>
                            {popular.map((item, index) => (
                                <QuickPickCard
                                    small={byPlatform(1, 3)}
                                    key={index}
                                    item={item}
                                    serverTime={this.props.serverTime}
                                />
                            ))}
                            <div style={{ clear: 'both' }} />
                        </TextFrame>
                    ) : null}

                    {today.length > 0 ? (
                        <TextFrame>
                            <Headline size="x2" condensed padding="10px">
                                {t.QuickPick.today}
                            </Headline>
                            {today.map((item, index) => (
                                <QuickPickCard
                                    small={byPlatform(1, 3)}
                                    key={index}
                                    item={item}
                                    serverTime={this.props.serverTime}
                                />
                            ))}
                            <div style={{ clear: 'both' }} />
                        </TextFrame>
                    ) : null}

                    {nextDays.length > 0 ? (
                        <TextFrame>
                            <Headline size="x2" condensed padding="10px">
                                {t.QuickPick.nextDays}
                            </Headline>
                            {nextDays.map((item, index) => (
                                <QuickPickCard
                                    small={byPlatform(1, 3)}
                                    key={index}
                                    item={item}
                                    serverTime={this.props.serverTime}
                                />
                            ))}
                            <div style={{ clear: 'both' }} />
                        </TextFrame>
                    ) : null}

                    {!this.state.data ? <Spinner size="x3" secondary /> : null}
                </Wrapper>
            </Wrapper>
        );
    }
}

export { PRODUCT_BACKGROUNDS };

const mapStateToProps = (state) => ({
    serverTime: state.AISDataProvider.serverTime,
});

const mapDispatchToProps = (dispatch) => {
    return {
        fetchServerTime: () => {
            dispatch(fetchServerTime());
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(QuickPick);
